<div class="_flex _flex-col _h-full _max-h-[90vh]">
    <div class="_flex _justify-between _pb-3 _mb-4 _border-b _border-transparency-black-5 _shadow-bottom">
        <div class="_text-h4 sm:_text-h3 _heading">More Resources</div>
        <i class="fa-light fa-xmark _cursor-pointer" mat-dialog-close></i>
    </div>

    <mat-dialog-content class="_flex-1 _min-h-0 _overflow-y-scroll _scrollbar _scrollbar-thin _scrollbar-track-gray-100 _scrollbar-thumb-gray-300 _pr-4">
        <ng-container *ngIf="documents.length">
            <ng-container *ngFor="let category of documents">
                <ng-container *ngIf="!category.isDefaultCategory && category.documents.length">
                    <div class="_h4 _mt-4">{{ category.name | titlecase }} Documents</div>
                    <div class="_py-4">
                        <a *ngFor="let document of category.documents" [href]="document.url" class="_link _mb-1" target="_blank">
                            <img app-imagekit [source]="document.url" transform="tr:w-50,h-50" thumbnail="true"  class="_border _border-primary-1-tint-20"/>
                            <span class="_underline">{{ formatName(document.name) }}</span>
                            <i class="fa-sharp fa-light" [ngClass]="isMediaFile(document.name) ? 'fa-photo-film' : 'fa-file'"></i>
                        </a>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
    </mat-dialog-content>
</div>

